import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import EpiContext from '@episerver/spa-core/Spa';
import TooltipPackageInfo from '../../Tooltip/TooltipPackageInfo';

const TvPackage = (props) => {
  const displayProductStatus = props.selectedSubscriber?.productStatus != 'Active' && props.selectedSubscriber?.productStatus != 'INS' && props.selectedSubscriber?.productStatus != 'A';
  const isTvApp = props.selectedSubscriber?.equipments == null || props.selectedSubscriber?.equipments?.length == 0;
  const tvEquipmentUrl = props.iContent.tvEquipmentUrl.value

  return (
    <div className='selfcare-package'>
      {props.isFetchData ?
        <div className='selfcare-package-wrapper'>
          <Image className='package-image' src={EpiContext.getEpiserverUrl(props.packageImage)} alt='tv' />
          <div className='content'>
            <div className={`header ${isTvApp ? 'tv-app' : ''}`}>
              <div className='title'>
                {isTvApp ? `אפליקציית ${window.Config.brand_Name_HE} TV` : `${window.Config.brand_Name_HE} TV`}
              </div>
              <div className='package-info'>
                {props.selectedSubscriber?.isBundle && <span className='bundle-text'>חלק מחבילה משולבת</span>}
                {displayProductStatus && <div className='status'>{props.selectedSubscriber?.productStatusDesc}</div>}
                <TooltipPackageInfo position='right' /> </div>
            </div>
            {!isTvApp &&
              <div className='equipments'>
                {props.selectedSubscriber?.equipments?.map((equipment, index) => {
                  const equipmentName = equipment.productDescription?.replace('ממיר', "");
                  return (<div className='equipment-name' key={index}> ממיר {index + 1} : {equipmentName}</div>)
                })
                }
                {tvEquipmentUrl && <a href="#" onClick={() => EpiContext.navigateTo(tvEquipmentUrl)}>לרשימת כל הציוד שלי {window.Config.brand_Name_HE} </a>}
              </div>
            }
          </div>
        </div> :
        <div style={{ display: 'flex', flex: '1', flexDirection: 'column', gap: '1px', width: '100%', height: '100%' }}>
          <Skeleton height={145} animation="wave" />
          <Skeleton height={72} animation="wave" />
          <Skeleton height={43} animation="wave" />
        </div>
      }
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isFullAuthenticated: state.authentication?.loginData?.isFullAuthenticated,
    isPrivate: state.authentication?.loginData?.userDetails?.isPrivate,
    selectedSubscriber: state.selfcarePage?.selectedSubscriber,
    isFetchData: state.selfcarePage?.isFetchData,

  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(TvPackage);
